import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 2 };
const _hoisted_5 = {
    key: 0,
    class: "mt-5 anchor-bottom"
};
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useContent } from '@/composables/useContent';
import FinancialFitnessBars from './elements/FinancialFitnessBars.vue';
import FinancialFitnessScore from './elements/FinancialFitnessScore.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FinancialFitnessHistoryPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getFinancialFitness, getPlans } = useContent();
        const financialFitnessHistory = ref(null);
        const scoreId = ref(null);
        function onLoad() {
            if (route.params.id) {
                scoreId.value = route.params.id;
            }
            getFinancialFitness(null, true);
            getFinancialFitness((fitness) => {
                financialFitnessHistory.value = fitness;
                if (scoreId.value) {
                    financialFitnessHistory.value = financialFitnessHistory.value.filter((f) => f.id === scoreId.value);
                }
                getPlans();
            });
        }
        function reTakeSurvey() {
            router.push({ path: '/FinancialFitness' });
        }
        function showScore(id) {
            router.push({ path: '/FinancialFitnessHistory/' + id });
        }
        function navigateTo(event) {
            const plan = state.plans?.find((p) => p.title === event);
            if (plan) {
                router.push({ path: '/Guides/' + plan.id });
            }
            else {
                router.push({ path: '/Guides' });
            }
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Financial Fitness" }),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (financialFitnessHistory.value && financialFitnessHistory.value[0] && _unref(state).plans)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                (!scoreId.value)
                                    ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Your current score"))
                                    : _createCommentVNode("", true),
                                (scoreId.value)
                                    ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "Your score"))
                                    : _createCommentVNode("", true),
                                (scoreId.value)
                                    ? (_openBlock(), _createElementBlock("h2", _hoisted_4, "On " + _toDisplayString(_unref(state).dateFormatPretty.format(new Date(financialFitnessHistory.value[0].createDateTime))), 1))
                                    : _createCommentVNode("", true),
                                _createVNode(FinancialFitnessScore, {
                                    class: "mt-5",
                                    dayToDay: financialFitnessHistory.value[0].dayToDay,
                                    future: financialFitnessHistory.value[0].future,
                                    security: financialFitnessHistory.value[0].security,
                                    started: financialFitnessHistory.value[0].started,
                                    score: financialFitnessHistory.value[0].score
                                }, null, 8, ["dayToDay", "future", "security", "started", "score"]),
                                _createVNode(FinancialFitnessBars, {
                                    onClick: navigateTo,
                                    dayToDay: financialFitnessHistory.value[0].dayToDay,
                                    future: financialFitnessHistory.value[0].future,
                                    security: financialFitnessHistory.value[0].security,
                                    started: financialFitnessHistory.value[0].started
                                }, null, 8, ["dayToDay", "future", "security", "started"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (financialFitnessHistory.value && financialFitnessHistory.value[1] && !scoreId.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("a", {
                                    onClick: _cache[0] || (_cache[0] = ($event) => (showScore(financialFitnessHistory.value[1].id)))
                                }, [
                                    _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "4" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(FinancialFitnessScore, {
                                                        class: "mt-2",
                                                        mini: "true",
                                                        dayToDay: financialFitnessHistory.value[1].dayToDay,
                                                        future: financialFitnessHistory.value[1].future,
                                                        security: financialFitnessHistory.value[1].security,
                                                        started: financialFitnessHistory.value[1].started,
                                                        score: financialFitnessHistory.value[1].score
                                                    }, null, 8, ["dayToDay", "future", "security", "started", "score"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, { class: "previousDetail" }, {
                                                default: _withCtx(() => [
                                                    _cache[1] || (_cache[1] = _createTextVNode(" Your previous score")),
                                                    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                                                    _createElementVNode("span", null, _toDisplayString(_unref(state).dateFormatPretty.format(new Date(financialFitnessHistory.value[1].createDateTime))), 1)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
